import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { FileUploadRoutingModule } from './file-upload-routing.module';
import { MutualFundsComponent } from './page/mutual-funds/mutual-funds.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { UploadHistoryComponent } from './page/upload-history/upload-history.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule  } from 'ngx-bootstrap/tooltip';
import { ClientOnboardingComponent } from './page/client-onboarding/client-onboarding.component';

@NgModule({
  declarations: [
    MutualFundsComponent,
    UploadHistoryComponent,
    ClientOnboardingComponent
  ],
  imports: [
    CommonModule,
    FileUploadRoutingModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgxPaginationModule,
    TooltipModule.forRoot() 
  ],
  providers: [DatePipe]
})
export class FileUploadModule { }
